/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelLastUserMessageRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'
import {CancelLastUserMessageResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'


export const cancelLastUserMessage = (request: CancelLastUserMessageRequest, options?: CashRequestOptions) => post<CancelLastUserMessageRequest, CancelLastUserMessageResponse>("/cash-app/goose-cash/v3/cancel-last-user-message", request, {...options, rejectOnError: true })